/* jscs:disable disallowFunctionDeclarations*/
(function(){
  'use strict';

  angular
    .module('AcaApp')
    .directive('ngHistStatusTransmittal', NgHistStatusTransmittal);

  function NgHistStatusTransmittal(){
    return {
      scope: {
        parent: '=',
        currentPage: '=',
        xmitFiles: '=',
        onClickRows: '&',
        goToReview: '&'
      },
      templateUrl: 'app/views/common/directives/historyStatus/historyStatusTransmittal.html',
      link: function(scope){
        scope.propertyName = 'timeoftransmittal';
        scope.onOrderChange = function(propertyName){
          scope.reverse = (scope.propertyName === propertyName) ? !scope.reverse : false;
          scope.propertyName = propertyName;
        };
        
        scope.hideColumns = window.sessionStorage.taxYear < 2020;
      }
    };
  }
})();